import React from 'react';
import { Divider } from 'primereact/divider';
import { Message } from 'primereact/message';
import { Button } from 'primereact/button';
import clsx from 'clsx';

const renderRecruitmentQuestions = ({ test }) => {
    const questions = [
        {
            question: "Parlez-nous de votre environnement de travail idéal: vous préférez un bureau et des projets individuels ou un environnement partagé et des projets d'équipe? Pourquoi?",
            tip: "Cette question vous aide à évaluer l'adaptabilité du candidat à la culture de l'entreprise."
        },
        {
            question: "Pensez à une nouvelle collègue avec qui vous alliez travailler sur une base régulière. Comment avez-vous procédé pour établir une relation avec cette personne?",
            tip: "Explorez les compétences relationnelles et la capacité de collaboration du candidat."
        }
    ];

    const healthQuestions = [
        {
            question: "Communiquer, si possible, avec un supérieur hiérarchique, un encadrant ou le service RH."
        },
        {
            question: "Consulter un médecin du travail ou un médecin traitant pour prévenir une éventuelle aggravation."
        },
        {
            question: "Contacter notre partenaire l’association SOS Burnout France (sosburnoutfrance@outlook.fr ou 06.50.30.24.26) pour un soutien dédié."
        }
    ];

    if (test.category === 'health') {
        return (
            <div className="container mt-6">
                <h2 className="title is-2 has-text-centered" style={{ color: '#5684c1' }}>Complément d'information</h2>
                <p className="subtitle is-5 has-text-centered mb-6">
                    Le test réalisé repose sur les recherches les plus récentes et fournit une évaluation indicative de l’état actuel d’une personne, semblable à une prise de température.
                </p>

                <div className="container is-max-desktop mt-6 mb-5">
                    <p className="has-text-justified is-size-5 mt-5 primary-text">
                        Les résultats, influencés par des facteurs individuels (expériences, culture) et contextuels (environnement, état émotionnel), doivent être considérés comme un outil complémentaire plutôt qu’une conclusion définitive.
                    </p>

                    <p className="has-text-justified is-size-5 mt-5 primary-text">
                        En cas de doute, les actions suivantes sont recommandées :
                    </p>

                    <ol>
                        {healthQuestions.map((item, index) => (
                            <div key={index}>
                                <li className='primary-text'>
                                    <p className="has-text-justified is-size-5 mt-5 primary-text">{item.question}</p>
                                </li>

                                <Divider />
                            </div>
                        ))}
                    </ol>

                    <p className="has-text-justified is-size-5 mt-5 primary-text">
                        Pour approfondir vos connaissances, des ressources sont disponibles sur le site de l’INRS. Ce test constitue une première étape dans une démarche de compréhension et de prise en charge. Pour toute question, notre équipe reste à votre disposition, et notre FAQ peut également vous être utile.
                    </p>
                </div>

            </div>
        );
    } else {
        return (
            <div className="container mt-6">
                <h2 className="title is-2 has-text-centered" style={{ color: '#5684c1' }}>Questions à poser en entretien</h2>
                <p className="subtitle is-5 has-text-centered mb-6">
                    Ces questions vous aideront à mieux comprendre le candidat et son adéquation avec l'équipe.
                </p>

                <div className="container is-max-desktop mt-6 mb-5">
                    <ol>
                        {questions.map((item, index) => (
                            <div key={index}>
                                <li className='primary-text'>
                                    <p className="has-text-justified is-size-5 mt-5 primary-text">{item.question}</p>

                                    <div className="has-text-centered">
                                        <Message severity="info" text={item.tip} />
                                    </div>

                                </li>

                                <Divider />
                            </div>
                        ))}
                    </ol>
                </div>

            </div>
        );
    }
};

export default renderRecruitmentQuestions;